import React from 'react';
import { useSelector } from 'react-redux';
import { Dialog, DialogContent, DialogTrigger } from '@radix-ui/react-dialog';
import '@radix-ui/themes/styles.css';
import { kababMenuOptions, sessionModeType } from 'types/Constants';

const ModalComp = (props) => {
  const sessionSettingData = useSelector((state:any) => state?.live.settings?.sessionSettingData);

  return (
    <Dialog open={props.visible} onOpenChange={props.onRequestClose}>
      <DialogContent
        className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center rounded-t-[4%]"
      >
        <div
          className="bg-white rounded-[3%] px-[3%] py-[3%] max-w-md w-full"
        >
          {props.text1 !== undefined && (
            <button className="flex flex-row items-center my-[0.5%]" onClick={props.onRequestClose}>
              <img
                src={props.image1}
                alt="Option 1"
                className="object-contain"
                style={{ height: '3.5%', width: '3.5%' }}
              />
              <span
                className="text-[#6B5399] text-[4%] pl-[2%]"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                {props.text1}
              </span>
            </button>
          )}

          {props.text3 !== undefined && (
            <button className="flex flex-row items-center my-[0.5%]" onClick={props.onRequestClose}>
              <img
                src={props.image3}
                alt="Option 3"
                className="object-contain"
                style={{ height: '3.5%', width: '3.5%' }}
              />
              <span
                className="text-[#6B5399] text-[4%] pl-[2%]"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                {props.text3}
              </span>
            </button>
          )}

          {props.text4 !== undefined && (
            <button className="flex flex-row items-center my-[0.5%]" onClick={props.onPressChat}>
              <img
                src={props.image4}
                alt="Option 4"
                className="object-contain"
                style={{ height: '3.5%', width: '3.5%' }}
              />
              <span
                className="text-[#6B5399] text-[4%] pl-[2%]"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                {props.text4}
              </span>
            </button>
          )}

          {props.text5 !== undefined && (
            <button className="flex flex-row items-center my-[0.5%]" onClick={props.onPressBadge}>
              <img
                src={props.image5}
                alt="Option 5"
                className="object-contain"
                style={{ height: '3.5%', width: '3.5%' }}
              />
              <span
                className="text-[#6B5399] text-[4%] pl-[2%]"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                {props.text5}
              </span>
            </button>
          )}

          {props.onVideoChat && (
            <button className="flex flex-row items-center my-[0.5%]" onClick={props.onVideoChat}>
              <img
                src={props.image4}
                alt="Video Chat"
                className="object-contain"
                style={{ height: '3.5%', width: '3.5%' }}
              />
              <span
                className="text-[#6B5399] text-[4%] pl-[2%]"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                {kababMenuOptions.START_VIDEO_CHAT}
              </span>
            </button>
          )}

          {props?.swapSeat === true && sessionSettingData?.sessionMode === sessionModeType?.NETWORKING_MODE && (
            <button className="flex flex-row items-center my-[0.5%]" onClick={props.onPressSwapSeat}>
              <img
                src="/assets/swapSeat.png"
                alt="Swap Seat"
                className="object-contain"
                style={{ height: '3.5%', width: '3.5%' }}
              />
              <span
                className="text-[#6B5399] text-[4%] pl-[2%]"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                Swap Seat
              </span>
            </button>
          )}

          {props.text2 !== undefined && sessionSettingData?.sessionMode === sessionModeType?.NETWORKING_MODE && (
            <button className="flex flex-row items-center my-[0.5%]" onClick={props.onShareVisitingCard}>
              <img
                src={props.image2}
                alt="Visiting Card"
                className="object-contain"
                style={{ height: '3.5%', width: '3.5%' }}
              />
              <span
                className="text-[#6B5399] text-[4%] pl-[2%]"
                style={{ fontFamily: "'Lato', sans-serif" }}
              >
                {props.text2}
              </span>
            </button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ModalComp;